export enum MutationTypes {
  SET_ISLOGGEDIN = "SET_ISLOGGEDIN",
}
